import React from 'react';
import styles from "./index.module.scss";
import classNames from "classnames";
import { Col, Row } from "antd";
import { ReactComponent as InstantLogo } from './images/instant-ink-logo.svg';

let cx = classNames.bind(styles);

const Hero = (props) => (
    <Row type="flex" className={styles.hero}>
        <Col xl={{offset: 3, span: 14}}>
            <div className={styles.heroPad}>
                <InstantLogo className={styles.heroLogo} width={190} height={70}/>
                
                <div className={styles.heroTxt}>Get the color and black ink you need starting at $2.99 a month</div>
                <div className={styles.heroBtns}>
                    <a href="https://instantink.hpconnected.com/" className={cx(styles.btn, styles.heroSignUp)}>Try free for 1 month</a>
                </div>
            </div>
        </Col>
    </Row>
);

export default Hero;
